import React from 'react'
import styles from './Footer.module.scss';
import Living from '../../assets/icon-footer.svg';

export const Footer = () => {
  return (
    <div className={styles.contentFooter}>
        <div className={styles.footer}>
            <p><span className='text-bold'>Living Rock</span>® 2025 Derechos reservados</p>
            <img alt='icon' src={Living}/>
        </div>
    </div>
  )
}
